export default {
  en: {
    additionalDetails: "Additional Details:",
    allSet: "You're all set! We have recorded your gift,",
    beforeContinuePayment: "Before confirming your payment would you",
    billingAddress1: "Billing Address 1",
    billingAddress2: "Billing Address 2",
    cardNumber: "card number",
    chooseGiving: "Choose Giving Destination",
    city: "City",
    confirmation: "Confirmation",
    continue: "CONTINUE",
    coverFee: "I will cover the transaction fees for my donation: ",
    creditCard: "Credit Card",
    cvv: "cvv",
    details: "Details",
    displayName: "Display Name",
    displayType: "Display as",
    donorDisplay: "Donor Display Information:",
    doubleDonation: "Employer Matching",
    donorNameDisplay: "Display my name as a donor",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "Email",
    expirationDate: "Expiration Date",
    firstName: "First Name",
    gift: "Gift",
    giftAmount: "Gift amount:",
    giftInformation: "Gift Information",
    giveNow: "GIVE NOW",
    giveSelectFund:
      "To give a donation select fund(s). The link allows you to add\nthe donation amount and proceed with payment.",
    givingTo: "I am giving to:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "Graduation Year",
    lastName: "Last Name",
    likeToDonateFunds: "Would you like to donate to these funds as well?",
    loggedInAs: "Logged in Name:",
    missingFields: "Please check form above for missing required information",
    next: "Next",
    notInterested: "NOT INTERESTED",
    payment: "Payment",
    payrollDeduction: "Payroll Deduction",
    phoneNumber: "Phone Number",
    proceedButton: "Proceed with Payment",
    province: "Province",
    postal: "Postal",
    receiveEmail: "and you will receive an email shortly.",
    relationship: "Relationship to Institution (select all that apply)",
    returnToSite: "Return to site",
    searchFunds: "Search funds...",
    selectCountry: "Select A Country",
    selectFund: "Please select a fund",
    selectLanguage: "Change language",
    state: "State",
    thankYou: "Thank You!",
    thankYouForGift: "Thank you for your gift of:",
    toChangeDonorPlease: "To change donor please",
    useDifferentEmail: "use different email address",
    zip: "Zip",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
    quickGive: "QuickGive",
    close: "Close",
  },
  cy: {
    additionalDetails: "Manylion Ychwanegol:",
    allSet: "Popeth yn iawn! Rydym wedi derbyn eich rhodd,",
    beforeContinuePayment: "Cyn cadarnhau eich taliad fyddech chi'n",
    billingAddress1: "Cyfeiriad Anfonebu 1",
    billingAddress2: "Cyfeiriad Anfonebu 2",
    cardNumber: "Rhif cerdyn",
    chooseGiving: "Choose Giving Destination",
    city: "dinas",
    confirmation: "Cadarnhau",
    continue: "PARHAU",
    coverFee: "Byddaf yn talu ffioedd gweinyddu fy rhodd: ",
    creditCard: "Cerdyn Credyd",
    cvv: "cvv",
    displayName: "Dangos Enw",
    displayType: "Dangos Math",
    donorDisplay: "Dangos Gwybodaeth am y Rhoddwr:",
    donorNameDisplay: "Dangoswch fy enw fel rhoddwr",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "E-bost",
    expirationDate: "Dyddiad Dod i Ben",
    firstName: "Enw Cyntaf",
    gift: "rhodd",
    giftAmount: "Swm y rhodd:",
    giftInformation: "Manylion y Rhodd",
    giveNow: "RHOI NAWR",
    giveSelectFund:
      "I roi rhodd dewiswch gronfa(gronfeydd). Mae'r ddolen yn caniatáu i chi ychwanegu swm y rhodd a mynd ymlaen i dalu.",
    givingTo: "Rydw i'n rhoi i:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "Blwyddyn Graddio",
    lastName: "Cyfenw",
    likeToDonateFunds: "Hoffech chi roi i'r cronfeydd hyn hefyd?",
    loggedInAs: "Wedi mewngofnodi dan Enw:",
    missingFields: "Gwiriwch y ffurflen am wybodaeth ofynnol sydd ar goll",
    next: "Nesaf",
    notInterested: "DIM DIDDORDEB",
    payment: "Taliad",
    payrollDeduction: "Didynnu o Gyflogres",
    phoneNumber: "Rhif Ffôn",
    proceedButton: "Symud ymlaen i Dalu",
    province: "Dalaith",
    postal: "Postal",
    receiveEmail: "a byddwch yn derbyn e-bost yn fuan.",
    relationship: "Perthynas â'r Sefydliad (dewiswch bob un sy'n berthnasol)",
    returnToSite: "Dychwelyd i'r wefan",
    searchFunds: "Chwilio cronfeydd...",
    selectCountry: "Dewiswch Wlad",
    selectFund: "Dewiswch Gronfa",
    selectLanguage: "Newidiwch iaith",
    state: "Talaith",
    thankYou: "Diolch yn fawr!",
    thankYouForGift: "Diolch am eich rhodd o:",
    toChangeDonorPlease: "I newid rhoddwr",
    useDifferentEmail: "defnyddio cyfeiriad e-bost gwahanol",
    zip: "Sip",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
  },
  de: {
    additionalDetails: "Weitere Informationen",
    allSet: "Los geht’s! Wir haben Ihre Spende erhalten.",
    beforeContinuePayment: "Bevor Sie die Transaktion freigeben würden Sie bitte",
    billingAddress1: "Adresszeile 1",
    billingAddress2: "Adresszeile 2",
    cardNumber: "Kartennummer",
    chooseGiving: "Choose Giving Destination",
    city: "Stadt",
    confirmation: "Bestätigung",
    continue: "Weiter",
    coverFee:
      "Gerne möchte ich auch die Bearbeitungsgebühren für meine Spende übernehmen: ",
    creditCard: "Kreditkarte",
    cvv: "CVV Nummer",
    displayName: "Name",
    displayType: "Anzeigetyp",
    donorDisplay: "Spender",
    donorNameDisplay: "Bitte nennen",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "Email",
    expirationDate: "Gültig bis",
    firstName: "Vorname",
    gift: "Spende",
    giftAmount: "Spendenhöhe",
    giftInformation: "Spendeninformation",
    giveNow: "JETZT SPENDEN",
    giveSelectFund:
      "Würden Sie vor der Bestätigung Ihrer Zahlung gerne zu diesen zusätzlichen Fonds spenden?",
    givingTo: "Meine Spende für:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "vMein Jahrgang",
    lastName: "Nachname",
    likeToDonateFunds: "Would you like to donate to these funds as well?",
    loggedInAs: "Eingeloggt wie:",
    missingFields: "Bitte fehlende Pflichtfelder ergänzen",
    next: "Weiter",
    notInterested: "Kein Interesse",
    payment: "Bezahlung",
    payrollDeduction: "Payroll Deduction",
    phoneNumber: "Telefonnummer",
    proceedButton: "Weiter",
    province: "Province",
    postal: "Postal",
    receiveEmail: "und Sie erhalten demnächst eine Email-Benachrichtigung.",
    relationship: "Beziehung zur Organisation",
    returnToSite: "Zürück",
    searchFunds: "Suchen...",
    selectCountry: "Bitte Land auswählen",
    selectFund: "Bitte auswählen",
    selectLanguage: "Sprache ändern",
    state: "Bundesland",
    thankYou: "Vielen Dank!",
    thankYouForGift: "Vielen Dank für Ihre Spende in Höhe von",
    toChangeDonorPlease: "To change donor please",
    useDifferentEmail: "Bitte eine andere Email-Adresse verwenden",
    zip: "PLZ",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
  },
  es: {
    additionalDetails: "Detalles Adicionales:",
    allSet: "¡Ya está todo listo! Grabamos tu donación,",
    beforeContinuePayment: "Antes de confirmar su pago, usted",
    billingAddress1: "Dirección de facturación 1",
    billingAddress2: "Dirección de facturación 2",
    cardNumber: "número de tarjeta",
    chooseGiving: "Choose Giving Destination",
    city: "ciudad",
    confirmation: "Confirmación",
    continue: "PROCEDER",
    coverFee: "&nbsp; Cubriré las tarifas de transacción de mi donación:",
    creditCard: "Tarjeta de crédito",
    cvv: "cvv",
    displayName: "Nombre en pantalla",
    displayType: "Tipo de pantalla",
    donorDisplay: "Información del donante:",
    donorNameDisplay: "Mostrar mi nombre como donante",
    email: "Correo electrónico",
    expirationDate: "Fecha de caducidad",
    firstName: "Nombre",
    gift: "Donación",
    giftAmount: "Valor de la donación:",
    giftInformation: "Información sobre donaciones",
    giveNow: "DOE AHORA",
    giveSelectFund:
      "Para hacer una donación, seleccione el fondo (s). El enlace le permite agregar el monto de la donación y proceder con el pago.",
    givingTo: "Estoy donando a:",
    googlePayApplePay: "Google Pay / Apple Pay",
    graduationYear: "Año de graduación",
    lastName: "Apellido",
    likeToDonateFunds: "¿Te gustaría donar a estos fondos también?",
    loggedInAs: "Nombre de inicio de sesión:",
    missingFields:
      "Consulte el formulario de arriba para obtener la información faltante necesaria",
    next: "Siguiente",
    notInterested: "NO INTERESADO",
    payment: "Pago",
    payrollDeduction: "Descuento en nómina",
    phoneNumber: "Número de teléfono",
    proceedButton: "Proceder con el pago",
    receiveEmail: "y pronto recibirás un correo electrónico.",
    relationship: "Relación con la Institución (seleccionar todo lo que se aplica)",
    returnToSite: "Volver al sitio",
    searchFunds: "Fondos de búsqueda...",
    selectCountry: "Seleccione un país",
    selectFund: "Seleccionar un fondo",
    selectLanguage: "Cambiar idioma",
    state: "Estado",
    thankYou: "Gracias!",
    thankYouForGift: "Gracias por su donación de:",
    toChangeDonorPlease: "Para cambiar de donante",
    useDifferentEmail: "usar una dirección de correo electrónico diferente",
    zip: "Código postal",
  },
  fr: {
    additionalDetails: "Détails supplémentaires:",
    allSet: "Vous êtes prêt ! Nous avons enregistré votre cadeau",
    beforeContinuePayment: "Avant de confirmer votre paiement, voudriez-vous",
    billingAddress1: "Adresse de facturation 1",
    billingAddress2: "Adresse de facturation 2",
    cardNumber: "numéro de carte",
    chooseGiving: "Choose Giving Destination",
    city: "ville",
    confirmation: "Confirmation",
    continue: "CONTINUEZ",
    coverFee: "Je couvrirai les frais de transaction de mon don:",
    creditCard: "Carte de crédit",
    cvv: "cvv",
    displayName: "Afficher un nom",
    displayType: "Type d'affichage",
    donorDisplay: "Informations sur l'affichage du donateur:",
    donorNameDisplay: "Afficher mon nom en tant que donateur",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "E-mail",
    expirationDate: "Date d'expiration",
    firstName: "Prénom",
    gift: "Cadeau",
    giftAmount: "Montant du cadeau:",
    giftInformation: "Informations",
    giveNow: "DONNE MAINTENANT",
    giveSelectFund:
      "Pour faire un don, sélectionnez le(s) fonds. Le lien vous permet d'ajouter\nle montant du don et de procéder au paiement.",
    givingTo: "Je donne à:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "Année d'obtention du diplôme",
    lastName: "Nom de famille",
    likeToDonateFunds: "souhaitez-vous également faire un don à ces fonds?",
    loggedInAs: "Nom de connexion:",
    missingFields:
      "Veuillez vérifier le formulaire ci-dessus pour les informations requises manquantes",
    next: "Suivant",
    notInterested: "PAS INTÉRESSÉ",
    payment: "Paiement",
    payrollDeduction: "Retenue à la source",
    phoneNumber: "Numéro de téléphone",
    proceedButton: "Procéder au paiement",
    province: "Province",
    postal: "Postal",
    receiveEmail: "et vous recevrez un e-mail sous peu",
    relationship: "Lien avec l'établissement (sélectionnez tout ce qui s'applique)",
    returnToSite: "Retour au site",
    searchFunds: "Rechercher des fonds...",
    selectCountry: "Choisissez un pays",
    selectFund: "Veuillez sélectionner un fonds",
    selectLanguage: "Changer de langue",
    state: "État",
    thankYou: "Merci!",
    thankYouForGift: "Merci pour votre don de:",
    toChangeDonorPlease: "Pour changer de donateur, veuillez",
    useDifferentEmail: "utiliser une adresse e-mail différente",
    zip: "code postal",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
  },
  hu: {
    additionalDetails: "Additional Details:",
    allSet: "You're all set! We have recorded your gift,",
    beforeContinuePayment: "Before confirming your payment would you",
    billingAddress1: "Billing Address 1",
    billingAddress2: "Billing Address 2",
    cardNumber: "card number",
    chooseGiving: "Choose Giving Destination",
    city: "city",
    confirmation: "Confirmation",
    continue: "CONTINUE",
    coverFee: "I will cover the transaction fees for my donation: ",
    creditCard: "Credit Card",
    cvv: "cvv",
    displayName: "Display Name",
    displayType: "Display as",
    donorDisplay: "Donor Display Information:",
    donorNameDisplay: "Display my name as a donor",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "Email",
    expirationDate: "Expiration Date",
    firstName: "First Name",
    gift: "Gift",
    giftAmount: "Gift amount:",
    giftInformation: "Gift Information",
    giveNow: "GIVE NOW",
    giveSelectFund:
      "To give a donation select fund(s). The link allows you to add\nthe donation amount and proceed with payment.",
    givingTo: "I am giving to:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "Graduation Year",
    lastName: "Last Name",
    likeToDonateFunds: "Would you like to donate to these funds as well?",
    loggedInAs: "Logged in Name:",
    missingFields: "Please check form above for missing required information",
    next: "Next",
    notInterested: "NOT INTERESTED",
    payment: "Payment",
    payrollDeduction: "Payroll Deduction",
    phoneNumber: "Phone Number",
    proceedButton: "Proceed with Payment",
    province: "Province",
    postal: "Postal",
    receiveEmail: "and you will receive an email shortly.",
    relationship: "Relationship to Institution (select all that apply)",
    returnToSite: "Return to site",
    searchFunds: "Search funds...",
    selectCountry: "Select A Country",
    selectFund: "Please select a fund",
    selectLanguage: "Change language",
    state: "State",
    thankYou: "Thank You!",
    thankYouForGift: "Thank you for your gift of:",
    toChangeDonorPlease: "To change donor please",
    useDifferentEmail: "use different email address",
    zip: "Zip",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
  },
  it: {
    additionalDetails: "dettagli aggiuntivi:",
    allSet: "È tutto pronto! Abbiamo registrato il tuo regalo",
    beforeContinuePayment: "Prima di confermare il pagamento",
    billingAddress1: "Indirizzo di fatturazione 1",
    billingAddress2: "Indirizzo di fatturazione 2",
    cardNumber: "numero di carta",
    chooseGiving: "Choose Giving Destination",
    city: "città",
    confirmation: "Conferma",
    continue: "CONTINUA",
    coverFee: "Coprirò le spese di transazione per la mia donazione",
    creditCard: "Carta di credito",
    cvv: "cvv",
    displayName: "Nome da visualizzare",
    displayType: "Tipo di visualizzazione",
    donorDisplay: "Informazioni sul display del donatore:",
    donorNameDisplay: "Mostra il mio nome come donatore",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "E-mail",
    expirationDate: "Data di scadenza",
    firstName: "Nome di battesimo",
    gift: "Regalo",
    giftAmount: "Importo regalo:",
    giftInformation: "Informazioni sui regali",
    giveNow: "DAI ORA",
    giveSelectFund:
      "Per fare una donazione seleziona il/i fondo/i. Il link permette di aggiungere\nl'importo della donazione e procedere con il pagamento.",
    givingTo: "sto dando a:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "SEPA Direct Debit",
    graduationYear: "anno di laurea",
    lastName: "Cognome",
    likeToDonateFunds: "vuoi donare anche a questi fondi?",
    loggedInAs: "Nome utente:",
    missingFields:
      "Si prega di controllare il modulo sopra per le informazioni richieste mancanti",
    next: "Prossimo",
    notInterested: "NON INTERESSATO",
    payment: "Pagamento",
    payrollDeduction: "Detrazione dallo stipendio",
    phoneNumber: "Numero di telefono",
    proceedButton: "Procedi con il pagamento",
    province: "Province",
    postal: "Postal",
    receiveEmail: "e riceverai una mail a breve",
    relationship: "Relazione con l'istituzione (seleziona tutte le risposte pertinenti)",
    returnToSite: "Ritorna al sito",
    searchFunds: "Cerca fondi...",
    selectCountry: "Seleziona un Paese",
    selectFund: "Seleziona un fondo",
    selectLanguage: "Cambia lingua",
    state: "Stato",
    thankYou: "Grazie!",
    thankYouForGift: "Grazie per il dono di:",
    toChangeDonorPlease: "Per favore cambia donatore",
    useDifferentEmail: "utilizzare un indirizzo email diverso",
    zip: "cap",
    onTime: "One time",
    or: "OR",
    recurring: "Recurring",
    donation: "Donation",
    paymentsPerYear: "Payments Per Year",
    monthly: "MONTHLY",
    monthlyPayment: "Monthly Payment",
    monthlyGift: "Make the gift monthly for",
    quarterly: "QUARTERLY",
    quarterlyPayment: "Quarterly Payment",
    quarterlyGift: "Make the gift quarterly for",
    annually: "ANNUALLY",
    annuallyPayment: "Annual Payment",
    annuallyGift: "Make the gift annually for",
    ongoing: "Ongoing",
    oneYear: "1 Year",
    twoYears: "2 Years",
    threeYears: "3 Years",
    fiveYears: "5 Years",
  },
  pt: {
    additionalDetails: "Detalhes Adicionais:",
    allSet: "Está tudo pronto! Gravamos seu Presente",
    beforeContinuePayment: "Antes de confirmar seu pagamento você faria",
    billingAddress1: "Endereço de faturamento 1",
    billingAddress2: "Endereço de faturamento 2",
    cardNumber: "Número do cartão",
    chooseGiving: "Escolha Dar Destino",
    city: "Cidade",
    confirmation: " Confirmação",
    continue: "CONTINUAR",
    coverFee: "Cobrirei as taxas de transação para minha doação: ",
    creditCard: "Cartão de crédito",
    cvv: "cvv",
    details: "Detalhes",
    displayName: "Exibir Nome",
    displayType: "Exibir Tipo",
    donorDisplay: "Informações do doador:",
    donorNameDisplay: "Mostrar meu nome como doador",
    selectAmbassador: "Select an Ambassador",
    ambassador: "Ambassador",
    email: "Email",
    expirationDate: "Data de expiração",
    firstName: "Primeiro nome",
    gift: "Presente",
    giftAmount: "Valor do Presente:",
    giftInformation: "Informações do presente",
    giveNow: "DOAR AGORA",
    giveSelectFund:
      "Para fazer uma doação, selecione o(s) fundo(s). O link permite que você adicione o valor da doação e prossiga com o pagamento.",
    givingTo: "Estou doando para:",
    googlePayApplePay: "Google Pay / Apple Pay",
    sepaDirectDebit: "Débito Directo SEPA",
    graduationYear: "Ano de Graduação",
    lastName: "Sobrenome/Apelido",
    likeToDonateFunds: "gostaria de doar para esses fundos também?",
    loggedInAs: "Nome conectado:",
    missingFields: "Por favor, verifique o formulário acima para informações faltantes",
    next: "Próximo",
    notInterested: "NÃO TENHO INTERESSE",
    payment: "Pagamento",
    payrollDeduction: "Dedução da folha de pagamento",
    phoneNumber: "Número de telefone",
    proceedButton: "Continuar com o Pagamento",
    province: "Provincia",
    postal: "Postal",
    receiveEmail: "e em breve você receberá um e-mail.",
    relationship: "Relação com a Instituição (selecione todas as opções aplicáveis)",
    returnToSite: "Retornar ao site",
    searchFunds: "Pesquisar fundos...",
    selectCountry: "Selecionar um país",
    selectFund: "Por favor, selecione um fundo",
    selectLanguage: "Mudar idioma",
    state: "Estado/Província",
    thankYou: "Obrigado(a)!",
    thankYouForGift: "Obrigado(a) por seu presente de:",
    toChangeDonorPlease: "Para mudar de doador, por favor",
    useDifferentEmail: "usar endereço de e-mail diferente",
    zip: "Código postal",
    onTime: "Uma vez",
    or: "OU",
    recurring: "Recorrente",
    donation: "Doação",
    paymentsPerYear: "Pagamentos por ano",
    monthly: "MENSALMENTE",
    monthlyPayment: "Pagamento mensal",
    monthlyGift: "Faça a doação mensalmente para",
    quarterly: "TRIMESTRAL",
    quarterlyPayment: "Pagamento trimestral",
    quarterlyGift: "Faça a doação trimestralmente para",
    annually: "ANUALMENTE",
    annuallyPayment: "Pagamento anual",
    annuallyGift: "Faça a doação anualmente para",
    ongoing: "Em andamento",
    oneYear: "1 ano",
    twoYears: "2 anos",
    threeYears: "3 anos",
    fiveYears: "5 anos",
  },
};
